import React, { useEffect, useState, useRef } from 'react';
import { AnimatePresence } from 'framer-motion';
import ServiceSection from './services/ServiceSection';
import { serviceData } from './services/ServiceData';
import { 
  GeneralServicesIllustration, 
  MobileAppIllustration, 
  WebHostingIllustration,
  LogoDesignIllustration,
  MakeAutomationIllustration,
  MobileIllustrations
} from './services/ServiceIllustrations';

const ServicesSection = () => {
  const [activeSection, setActiveSection] = useState(0);
  const sectionRefs = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)];
  const containerRef = useRef(null);
  
  useEffect(() => {
    const handleScroll = () => {
      // Vérifier si le conteneur est visible
      if (containerRef.current) {
        const containerRect = containerRef.current.getBoundingClientRect();
        const isContainerVisible = containerRect.top <= 0;
        
        // Vérifier quelle section est visible
        sectionRefs.forEach((ref, index) => {
          if (ref.current) {
            const { top, bottom } = ref.current.getBoundingClientRect();
            const isVisible = top < window.innerHeight / 2 && bottom > window.innerHeight / 2;
            
            if (isVisible && isContainerVisible) {
              setActiveSection(index);
            }
          }
        });
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [sectionRefs]);

  // Fonction pour obtenir l'illustration correspondante à la section active
  const getIllustration = (index) => {
    switch(index) {
      case 0:
        return <GeneralServicesIllustration />;
      case 1:
        return <MobileAppIllustration />;
      case 2:
        return <WebHostingIllustration />;
      case 3:
        return <LogoDesignIllustration />;
      case 4:
        return <MakeAutomationIllustration />;
      default:
        return null;
    }
  };

  return (
    <section id="services" className="relative bg-white" ref={containerRef}>
      <div className="container mx-auto px-4 md:px-8 lg:px-16">
        <div className="flex flex-col md:flex-row">
          {/* Contenu de gauche (défilant) */}
          <div className="w-full md:w-1/2 md:pr-8 md:pl-8">
            {/* Sections de service */}
            {serviceData.map((service, index) => (
              <ServiceSection
                key={service.id}
                reference={sectionRefs[index]}
                badge={service.badge}
                titleLines={service.titleLines}
                description={service.description}
                buttonText={service.buttonText}
              />
            ))}
          </div>
          
          {/* Conteneur sticky pour le contenu de droite - masqué sur mobile */}
          <div className="hidden md:block md:w-1/2">
            <div className="sticky top-0 h-screen w-full flex items-center justify-center">
              <AnimatePresence mode="wait">
                {getIllustration(activeSection)}
              </AnimatePresence>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
